module.exports = __webpack_public_path__ + "static/media/radiance.47dc27ca.png";